import { connect } from 'react-redux';

import ToggleForm from './ToggleForm';

const mapStateToProps = state => {
  return {
    drawerTitle: state.rolesPermissions.drawerTitle,
  };
};

export default connect(mapStateToProps)(ToggleForm);
